import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_notification_type.js";
//#region src/kiosk_notification_type_helper.ts
var kiosk_notification_type_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(notificationType) {
	switch (notificationType) {
		case 20: return "App Logout";
		case 24: return "App Login";
		case 18: return "App Update";
		case 27: return "ChromeOS Build Update";
		case 26: return "Garcon Build Update";
		case 25: return "Vitrine Build Update";
		case 9: return "Update Kiosk Config";
		case 6: return "Disable ASAM";
		case 5: return "Enable ASAM";
		case 8: return "Kiosk Update";
		case 11: return "Menu Update";
		case 17: return "Payment Terminal Status Update";
		case 21: return "Refund Request";
		case 2: return "Request Logs";
		case 3: return "Take Screenshot";
		case 7: return "Request Status";
		case 1: return "Restart App";
		case 23: return "Run Speed Test";
		case 16: return "Run Whitelist Test";
		case 10: return "Test Print";
		case 4: return "Update Payment Terminal";
		case 15: return "Upload Payment Terminal Logs";
		case 22: return "Menu Update No Change";
		case 28: return "Reboot Payment Terminal";
		case 29: return "Return To Config";
		case 30: return "Live View Click";
		case 31: return "Live View Scroll";
	}
}
//#endregion
export { kiosk_notification_type_helper_exports, name };

//# sourceMappingURL=kiosk_notification_type_helper.js.map